// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__nG5zr","main":"Checkbox_main__2ezXq"};